// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleEndPlateInfoVO } from '@article/model/vo/article-end-plate-info-vo';

@Component({
  standalone: false,
  selector: 'app-edit-endplate',
  templateUrl: './edit-endplate.component.html',
  styleUrls: ['./edit-endplate.component.scss'],
})
export class EditEndplateComponent implements OnInit {

  @Input() public endPlate: ArticleEndPlateInfoVO;
  @Output() public finish = new EventEmitter<boolean>();

  public form: FormGroup;
  public rotated;

  constructor(
    private bsModalRef: BsModalRef,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      articleNumber: new FormControl({
        value: this.endPlate.articleNo,
        disabled: true,
      }),
      otherArticleNumber: new FormControl({
        value: this.endPlate.otherArticleNo,
        disabled: true,
      }),
      rotated: new FormControl(this.endPlate.rotated),
    });
    this.rotated = this.endPlate.rotated;
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    this.finish.emit(this.rotated);
    this.close();
  }
}
